module.exports = __webpack_public_path__ + "img/p_icon06.be6c743a.svg";